import { Trip } from "@fairfleet/geotab";
import type { Interval } from "date-fns";

/**
 * Returns an {@link Interval} object from the given {@link Trip}.
 * @param trip - The trip to get the interval from.
 * @returns - The interval of the trip.
 */
export function tripInterval(trip: Trip) {
  return {
    start: trip.start,
    end: trip.stop,
  } satisfies Interval;
}
